import { render, staticRenderFns } from "./DeliveryUnavailableReason.vue?vue&type=template&id=14f66b64"
import script from "./DeliveryUnavailableReason.vue?vue&type=script&lang=js"
export * from "./DeliveryUnavailableReason.vue?vue&type=script&lang=js"
import style0 from "./DeliveryUnavailableReason.vue?vue&type=style&index=0&id=14f66b64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports